import { useSelector } from 'react-redux';
import SpeakToYourAgentCardShort from 'components/SpeakToYourAgentCardShort';
import DefaultHeader from 'components/pageLayout/DefaultHeader';
import Layout from 'components/pageLayout/Layout';
import PageContentContainer from 'components/pageLayout/PageContentContainer';
import { getStringValue } from 'shared/helpers/common';
import OverviewTab from '../quoteBookingDetailsPageOverviewTab/OverviewTab';

export default function QuotesDetailsPage() {
  const { selectedQuote, componentConfig } = useSelector((state) => state.ui);

  return (
    <Layout>
      <DefaultHeader
        label={`Quote ${getStringValue(selectedQuote?.reference)}`}
        authorName={selectedQuote.author.name || selectedQuote.author.fullName}
      />
      <PageContentContainer>
        <div className="mx-4 lg:flex lg:gap-4 md:items-start">
          <div className="grow lg:mr-4 lg:mb-14">
            <OverviewTab data={selectedQuote} isBooking={false} />
          </div>
          {componentConfig.contactAgentEnabled && (
            <SpeakToYourAgentCardShort type="quote" context="quote" />
          )}
        </div>
      </PageContentContainer>
    </Layout>
  );
}
